/**
 * Referral tracking:
 * - On mount, if URL has ?ref=CODE, store it in localStorage with 30-day expiry.
 * - Also fire a POST /affiliate/track to record the click (session_key = a random opaque id).
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const REF_KEY = "stageletics_ref";
const SESSION_KEY = "stageletics_ref_session";
const TTL_DAYS = 30;

function getSessionKey() {
  let sk = localStorage.getItem(SESSION_KEY);
  if (!sk) {
    sk = crypto.randomUUID ? crypto.randomUUID().replace(/-/g, "") : Math.random().toString(36).slice(2) + Date.now();
    localStorage.setItem(SESSION_KEY, sk);
  }
  return sk;
}

export function readRefCode() {
  try {
    const raw = localStorage.getItem(REF_KEY);
    if (!raw) return null;
    const { code, expiresAt } = JSON.parse(raw);
    if (Date.now() > expiresAt) {
      localStorage.removeItem(REF_KEY);
      return null;
    }
    return code || null;
  } catch {
    return null;
  }
}

export default function RefTracker() {
  const loc = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(loc.search);
    const ref = params.get("ref");
    if (!ref) return;
    const code = ref.trim().toUpperCase();
    if (!/^[A-Z0-9_-]{2,40}$/.test(code)) return;
    const expiresAt = Date.now() + TTL_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(REF_KEY, JSON.stringify({ code, expiresAt }));
    axios
      .post(`${API}/affiliate/track`, {
        code,
        session_key: getSessionKey(),
        referrer: document.referrer || "",
      })
      .catch(() => { /* fire-and-forget; silent */ });
  }, [loc.search]);
  return null;
}
